import axios from '@/plugins/axios';

const initialState = () => {
    return {
        contracts: [],
        deletedContracts: [],
        endingContracts: []
    };
};

const state = () => initialState();

const getters = {
    getContracts: state => state.contracts,
    getDeletedContracts: state => state.deletedContracts,
    getEndingContracts: state => state.endingContracts,
    getContractById: state => (contractId, type = 'contracts') =>
        state[type].find(contract => contract.id === contractId)
};

const mutations = {
    setContracts: (state, contracts) => {
        state.contracts = contracts;
    },
    setDeletedContracts: (state, contracts) => {
        state.deletedContracts = contracts;
    },
    setEndingContracts: (state, contracts) => {
        state.endingContracts = contracts;
    },
    addContract: (state, contract) => {
        state.contracts.unshift(contract);
    },
    addDeletedContract: (state, contract) => {
        state.deletedContracts.unshift(contract);
    },
    deleteContract: (state, contract) => {
        state.contracts = state.contracts.filter(c => c.id !== contract.id);
    },
    deleteDeletedContract: (state, contract) => {
        state.deletedContracts = state.deletedContracts.filter(
            c => c.id !== contract.id
        );
    },
    setContract: (state, contract) => {
        const contractIndex = state.contracts.findIndex(
            c => c.id === contract.id
        );

        if (~contractIndex) {
            state.contracts.splice(contractIndex, 1, contract);
        }
    },
    clearState: state => {
        state.contracts = [];
        state.endingContracts = [];
    }
};

const actions = {
    async fetch({ commit }) {
        const { data } = await axios.get('/contracts');

        commit('setContracts', data);

        return data;
    },

    async fetchEnding({ commit }) {
        const { data } = await axios.get('/contracts', {
            params: {
                filter: {
                    lastEndingOnly: true
                }
            }
        });

        commit('setEndingContracts', data);

        return data;
    },

    async fetchDeleted({ commit }) {
        const { data } = await axios.get('/contracts', {
            params: { includeDeleted: true }
        });
        commit('setDeletedContracts', data);

        return data;
    },

    async save({ commit }, contract) {
        if (contract.id) {
            const { data } = await axios.put(
                `/contracts/${contract.id}`,
                contract
            );

            commit('setContract', data);
            commit('users/setUser', data.user, { root: true });
        } else {
            const { data } = await axios.post('/contracts', contract);

            commit('addContract', data);
            commit('users/setUser', data.user, { root: true });
        }
    },

    async delete({ commit, getters }, contractId) {
        await axios.delete(`/contracts/${contractId}`);

        const contract = getters.getContractById(contractId);

        const { data } = await axios.get(`/users/${contract.userId}`);

        commit('deleteContract', contract);
        commit('addDeletedContract', contract);
        commit('users/setUser', data, { root: true });
    },

    async restore({ commit, getters }, contractId) {
        await axios.put(`/contracts/${contractId}/restore`);

        const contract = getters.getContractById(
            contractId,
            'deletedContracts'
        );

        const { data } = await axios.get(`/users/${contract.userId}`);

        commit('addContract', contract);
        commit('deleteDeletedContract', contract);
        commit('users/setUser', data, { root: true });
    },

    async changeStatus({ commit }, { contractId, status }) {
        const { data } = await axios.put(`/contracts/${contractId}/status`, {
            status
        });

        commit('setContract', data);
    },

    async fetchHistoriesByEntityId(vuexContext, entityId) {
        const { data } = await axios.get(`/history/contracts/${entityId}`);

        return data;
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
};
